module.exports = __webpack_public_path__ + "img/tutorial_doubts_02.447f1f5f.gif";